'use client'

import { Plus } from 'lucide-react'

/**
 * Hover-reveal add control. Variants match block context (list / zone / inline / workflow).
 */
export function BlockListAdd({
  label,
  onClick,
  disabled = false,
  className = '',
  variant = 'list',
}) {
  const showLabel = variant === 'list' && label

  return (
    <button
      type="button"
      className={[
        'nb-add',
        `nb-add--${variant}`,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onClick}
      disabled={disabled}
      title={label || 'Add'}
      aria-label={label || 'Add'}
    >
      <Plus
        size={variant === 'inline' || variant === 'zone' ? 11 : 12}
        strokeWidth={2}
      />
      {showLabel ? <span className="nb-add__label">{label}</span> : null}
    </button>
  )
}
